export default class ImagePreviewModel {
  ImageUrl: string = "";
  Width: number = 0;
  Height: number = 0;
  Top: number = 0;
  Left: number = 0;

  constructor(object?: Partial<ImagePreviewModel>) {
    if (object) {
      Object.assign(this, object);
    }
  }
}